import { render, staticRenderFns } from "./SearchGameList.vue?vue&type=template&id=3a636abd&scoped=true"
import script from "./SearchGameList.vue?vue&type=script&lang=js"
export * from "./SearchGameList.vue?vue&type=script&lang=js"
import style0 from "./SearchGameList.vue?vue&type=style&index=0&id=3a636abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a636abd",
  null
  
)

export default component.exports